import React from "react";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$lang/rtk")({
  component: React.lazy(() =>
    import("@/pages/information/rtk").then((mod) => ({
      default: mod.RtkPage,
    })),
  ),
});
